<template>
  <a-spin :spinning="false" tip="登录中，请稍候……">
    <div class="login">
      <div class="cubeName">
        <img src="@/assets/UniversityLogo.png" alt="">
        <span >{{system}}</span>
      </div>
        <div class="form">
          <div class="form-item">
            <div class="label">登录账号</div>
            <div class="input-wrap">
              <a-input v-model="accountNum" placeholder="请输入您的手机号码" />
            </div>
          </div>
          <div class="form-item">
            <div class="label">
              输入密码
            </div>
            <div class="input-wrap">
              <a-input-password
                v-model="password"
                placeholder="请输入您的密码"
              />
            </div>
          </div>
          <div class="form-item" v-show="needVerifyCode">
            <div class="label">验证码</div>
            <div class="input-wrap">
              <div class="img-code">
                <img
                  :src="imgUrl + '&random=' + randoms"
                  alt=""
                  @click="randoms = Math.random()"
                />
              </div>
              <a-input
                v-model="verifyCode"
                class="verifycode"
                style="width: 278px;border-radius: 4px 0px 0px 4px;"
              />
            </div>
          </div>
          <div class="form-item" style="margin-top: 0">
            <a-button
              type="primary"
              size="large"
              class="login-btn"
              @click="login"
              block
              >立即登录</a-button
            >
          </div>
        </div>

      <a-modal
        v-model="successVisible"
        wrapClassName="success-win"
        title=""
        :closable="false"
        centered
        :footer="null"
      >
        <div class="content">
          <a-icon type="check-circle" theme="filled" />
          <div class="tips1">恭喜您，登录成功！</div>
          <div class="btns">
            <a-button type="primary" @click="goVisit(0)">去门户首页</a-button>
            <a-button type="primary" @click="goVisit(1)">去数据查询</a-button>
            <a-button type="primary" @click="goVisit(2)">去数据录入</a-button>
          </div>
        </div>
      </a-modal>
    </div>
  </a-spin>
</template>

<script>
import config from "../../until/configs";
import { isPhone, messageTips, getCookie,setCookie,delCookie} from "../../until/tools";
export default {
  name: "Login",
  data() {
    return {
      system:'',
      buttonText: "获取验证码",
      accountNum: "",
      password: "",
      verifyCode: "",
      successVisible: false,
      sid: "",
      needVerifyCode: false,
      imgUrl: "",
      randoms: "",
      spinning: false,
    };
  },
  methods: {
    login() {
      if (this.accountNum === "") {
        messageTips("请输入手机号码", 2);
        return false;
      }
      if (!isPhone(this.accountNum)) {
        messageTips("手机号码格式不正确", 2);
        return false;
      }
      if (this.password === "") {
        messageTips("请输入密码", 2);
        return false;
      }
      let params = {
        account: this.accountNum,
        password: this.password,
        loginType: "pwd",
      };
      this.$http.isNeedVerifyCode({ account: params.account }).then((res) => {
        if (res.needVerifyCode) {
        this.needVerifyCode = true;
        if (this.verifyCode === "") {
          messageTips("请输入验证码", 2);
          this.$http.getSign({ account: this.accountNum }).then((res) => {
            if (res) {
              if (res.sign) {
                this.imgUrl =
                  config.imgCode +
                  "?account=" +
                  this.accountNum +
                  "&sign" +
                  res.sign;
              }
            }
          });
          return false;
        } else {
          params.imageCode = this.verifyCode;
          this.continueLogin(params);
        }
        } else {
        this.continueLogin(params);
        }
      });
    },
    continueLogin(params) {
      this.spinning = true;
      this.$http.login(params).then((res) => {
        if (res) {
          if (res.sid) {
              setCookie("bd_sid", res.sid, { time: 1 });
              this.sid = res.sid;
              if (res.canInput === 1) {
                // this.successVisible=true//不弹框
                this.spinning = false;
                if (getCookie("loginTargetUrl")) {
                  let loginTargetUrl = getCookie("loginTargetUrl");
                  this.$router.push(loginTargetUrl);
                  delCookie("loginTargetUrl");
                } else {
                  this.goVisit(0)
                }
                setCookie("canInput", res.canInput, { time: 1 });
              } else {
                messageTips('该账号无录入权限',2)
              }
          } else {
            this.spinning = false;
            messageTips(res.message, 1);
          }
        }
      });
    },
    goVisit(type) {
      if(type === 0){
        this.$router.push({ path: "/newHome" });
      }
      else if (type === 1) {
        this.$router.push({ path: "/datas_data" });
      } else {
        this.$router.push({ path: "/inputs_cube" });
      }
    },
  },
  mounted() {
    const loginTargetUrl = getCookie('loginTargetUrl');
    const condition1 = loginTargetUrl.includes('/cloud') || loginTargetUrl.includes('/datas_') || loginTargetUrl.includes('/user')|| loginTargetUrl.includes('/analysis');
    const condition2 = loginTargetUrl.includes('/calculate') || loginTargetUrl.includes('/inputs');
    
    // //首页
    // console.log(getCookie('loginTargetUrl').includes('/newHome'));
    // //录入
    // console.log(getCookie('loginTargetUrl').includes('/inputs'));
    // console.log(getCookie('loginTargetUrl').includes('/calculate'));
    // //个人信息 属于查询
    // console.log(getCookie('loginTargetUrl').includes('/user'));
    // console.log(getCookie('loginTargetUrl').includes('/datas_'));
    // console.log(getCookie('loginTargetUrl').includes('/cloud'));
    if(condition1){
      this.system='内蒙古基层治理数据中心'
    }else if(condition2){
      this.system='内蒙古基层治理数据中心'
    }else{
      this.system='门户系统'
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/login.scss";
</style>
